export default "__VITE_ASSET__8b143c92__"